export const setCartQuantityCookie = (cart) => {
  let cartQuantity = 0;
  if (cart.orderRows && cart.orderRows.length > 0) {
    cartQuantity = cart.orderRows.reduce(
      (total, row) => total + row.quantity,
      0
    );
  }
    var expires = new Date(new Date().getTime() + 60 * (1000 * 60));
    var externalSuzukiWebDomain = cart.externalSuzukiWebDomain;

    document.cookie = `SuzukiShoppingCartQuantity=${cartQuantity}; expires="${expires}"; domain=${externalSuzukiWebDomain}; path=/`;
};
